// @ts-nocheck
/* eslint-disable */
export const appReport24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3L12 3L19 3L19 21L5 21L5 3Z" stroke="currentColor" stroke-width="2"/><path d="M8 14L16 14" stroke="currentColor" stroke-width="2"/><path opacity="0.5" d="M8 10L10.5 7.5L12.5 9.5L16 6" stroke="currentColor" stroke-width="2"/><path opacity="0.5" d="M8 17L14 17" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'report-24' as const
};